import { Environment } from './environment.model';
/* Environment used for dynamic environments. Properties are set with
 * with placeholder strings which are replaced by dynamic values during the
 * build
 */

export const environment: Environment = {
  isProd: false,
  isLocal: false,
  assetsHost: 'https://zav.westermann.de',
  apiUrl: 'https://backend.next.zav.westermann.de/api/v2',
  learningSectionPreviewHost: 'https://lernmodule.westermann.de',
  learningSectionPreviewToken: '68e647c8fa2883318365e3921e527dd5',
  name: 'production',
  sentry: {
    // disabled in feature branches
    dsn: ''
  },
  playerBaseUrl: 'https://player2.zav.westermann.de',
  backendUrl: 'https://backend.next.zav.westermann.de'
};
